module.exports = "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICI4OTg4OTY4ODE0N2JkNzU3NWQ2MzI3MTYwZDY0ZTc2MC5zdmciOw=="


//////////////////
// WEBPACK FOOTER
// ../~/bootstrap-sass/assets/fonts/bootstrap/glyphicons-halflings-regular.svg
// module id = 58
// module chunks = 0